module.exports = __webpack_public_path__ + "static/media/Program15.4a2f8f31.jpg";